module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/media/personality-relax-riben.c60a8b63.webm";